const staticData = () => {
  const types = ["apartment", "house", "plot", "commercial"];
  const pakistanMajorCities = [
    "Lahore",
    "Karachi",
    "Islamabad",
    "Rawalpindi",
    "Faisalabad",
    "Multan",
    "Gujranwala",
    "Sialkot",
    "Gujrat",
    "Sargodha",
    "Sheikhupura",
    "Bahawalpur",
    "Rahim Yar Khan",
    "Sukkur",
    "Hyderabad",
    "Larkana",
    "Quetta",
    "Peshawar",
    "Mardan",
    "Abbottabad",
    "Swat",
    "Nowshera",
    "Mingora",
    "Dera Ismail Khan",
    "Dera Ghazi Khan",
    "Muzaffarabad",
    "Mirpur",
    "Gilgit",
    "Skardu",
  ];

  return {
    types,
    pakistanMajorCities,
  };
};

export default staticData;
